import {Component, OnInit} from '@angular/core';
import {Pregunta} from '../../model/pregunta';
import {Opcion} from '../../model/opcion';
import {Asistente} from '../../model/asistente';
import {Votacion} from '../../model/votacion';
import {Validators, UntypedFormControl, UntypedFormArray, UntypedFormGroup, UntypedFormBuilder} from '@angular/forms';
import {AlertaService} from 'src/app/util/alerta.service';
import {VotacionService} from '../votacion.service';
import {Router} from '@angular/router';

@Component({
  selector: 'sura-votacion',
  templateUrl: './votacion.component.html',
  styleUrls: ['./votacion.component.scss']
})
export class VotacionComponent implements OnInit {
  votacion = new Votacion();
  // opcionSelected = new Opcion();
  preguntaBD: Pregunta = new Pregunta();
  asistente: Asistente = new Asistente();
  formGroup: UntypedFormGroup;
  votacionValidacion = new UntypedFormControl('', [Validators.required]);
  votacionMultipleValidacion = new UntypedFormArray([]);

  constructor(private router: Router, private _votacionService: VotacionService,
    private alertaService: AlertaService, private formBuilder: UntypedFormBuilder) {
  }

  enviarVotacion() {
    const tipoPregunta = this.preguntaBD.tipoPregunta;

    if (tipoPregunta === 2) {
      if (this.formGroup.controls.votacionMultipleValidacion.value.length !== this.preguntaBD.numOpc) {
        this.alertaService.warning(`Para la pregunta actual debe de seleccionar ${this.preguntaBD.numOpc} opciones`);
        return;
      }
    }

    if ((tipoPregunta === 1 && this.votacionValidacion.valid) ||
        (tipoPregunta === 2 && this.votacionMultipleValidacion.valid) ) {
      this.votacion.idOpcion = this.preguntaBD.opciones[0].id;
      this.votacion.voto = tipoPregunta === 2 ?
                                        this.formGroup.controls.votacionMultipleValidacion.value.toString() :
                                        this.votacionValidacion.value.descripcion;
      this.votacion.idAsamblea = this.asistente.idAsamblea;
      this.votacion.idFoto = this.asistente.id;
      this.votacion.idFoto = this.asistente.idFoto;
      this.votacion.idPregunta = this.preguntaBD.id;
      this.votacion.peso = this.asistente.peso;
      if(sessionStorage.getItem('votanteactivo') == 'S'){
      this.votacion.usuarioRegistro = this.asistente.usuarioRegistro;
      }else{
        this.votacion.usuarioRegistro = this.asistente.nombres + ' ' + this.asistente.apellidos;;
      }
      this._votacionService.generarVotacion(this.votacion).then(res => {
          this.votacionValidacion.reset();
          this.cleanValidationPreguntaMultiple();

          this.alertaService.success(res);
          this.obtenerPreguntaActiva();
        }
      ).catch(err => {
        this.alertaService.error(err);
      });
    }
  }

  ngOnInit() {
    this.formGroup = this.formBuilder.group({
      votacionMultipleValidacion: this.formBuilder.array([])
    });

    if(sessionStorage.getItem('votanteactivo') == 'S'){
      const votanteActual = localStorage.getItem('votanteActual');
      let asistenteTemp = this._votacionService.getCurrentUser() || new Asistente;

      if (votanteActual) {
        this.asistente = JSON.parse(votanteActual);
        this.asistente.usuarioRegistro = asistenteTemp.nombres + ' ' + asistenteTemp.apellidos;
      }
    }else{ 
    this.asistente = this._votacionService.getCurrentUser() || new Asistente;

    }

    this.obtenerPreguntaActiva();
  }

  obtenerOpcionesPregunta(_Pregunta: Pregunta) {
    this._votacionService.obtenerOpciones(_Pregunta.id, 0, 0).then(
      ops => {
        const obj = ops[0];
        const arrayString = obj.descripcion.split(',');
        const arrayOpciones: Opcion[] = [];
        for (let index = 0; index < arrayString.length; index++) {
          const valor = arrayString[index];
          const opcion = new Opcion();
          opcion.descripcion = valor;
          opcion.id = obj.id;
          arrayOpciones.push(opcion);
        }
        this.preguntaBD = _Pregunta;
        this.preguntaBD.opciones = arrayOpciones;
      }
    ).catch(err => {
      this.alertaService.error(err);
    });
  }

  onChange(event) {
    const opciones = this.formGroup.get('votacionMultipleValidacion') as UntypedFormArray;

    if (event.checked) {
      opciones.push(new UntypedFormControl(event.source.value));
    } else {
      const i = opciones.controls.findIndex(x => x.value === event.source.value);
      opciones.removeAt(i);
    }
  }

  cleanValidationPreguntaMultiple() {
    this.formGroup = this.formBuilder.group({
      votacionMultipleValidacion: this.formBuilder.array([])
    });
  }


  verificarVotacionCompleta(key: string = 'estadoBienvenida'): boolean {
      try {
        const datosStr = sessionStorage.getItem(key);
        if (!datosStr) return false;
        
        const datos = JSON.parse(datosStr);
        const todosVotantes = [
          ...(datos.votantesPropios || []),
          ...(datos.votantesDelegados || [])
        ];
        
        // Filtrar SOLO los votantes que PUEDEN votar
        const votantesQuePuedenVotar = todosVotantes.filter(v => v.puedeVotar === true);
        if (votantesQuePuedenVotar.length === 0) return true;
        return votantesQuePuedenVotar.every(v => v.yaVoto === true);
      } catch {
        return false;
      }
  }

  obtenerPreguntaActiva() {
    this._votacionService.obtenerPreguntaActiva(
      this.asistente.idAsamblea,
      this.asistente.id,
      this.asistente.idFoto,
      'M',
      'P'
    )
    .then(preg => {
      if (preg instanceof Array && preg.length === 0) {

        if(sessionStorage.getItem('votanteactivo') == 'S'){
          const completado = this.verificarVotacionCompleta();
         if(completado){
           this.router.navigate(['/finVotacion/' + this.asistente.idAsamblea], {skipLocationChange: true});
            localStorage.removeItem('votanteActual');
            localStorage.removeItem('votanteactivo');
          }else{ 
           this.router.navigate(['/bienvenido']);
          }
        }else{
            this.router.navigate(['/finVotacion/' + this.asistente.idAsamblea], {skipLocationChange: true});
            localStorage.removeItem('votanteActual');
            localStorage.removeItem('votanteactivo');
        }
       
      } else {
        this.obtenerOpcionesPregunta(preg[0]);
      }
    }).catch(err => {
          if(sessionStorage.getItem('votanteactivo') == 'S'){
               const completado = this.verificarVotacionCompleta();
              if(completado){
                this.router.navigate(['/finVotacion/' + this.asistente.idAsamblea], {skipLocationChange: true});
                  localStorage.removeItem('votanteActual');
                  localStorage.removeItem('votanteactivo');
                }else{ 
                    this.router.navigate(['/bienvenido']);
                }
          }else{
        
              if(err == "Participe o representante ya voto"){
                this._votacionService.votacionHistorico(this.asistente.idAsamblea, this.asistente.idFoto).then(r => {
                  this.router.navigate(['/finVotacion/' + this.asistente.idAsamblea], {skipLocationChange: true});
                }).catch(err => {
                  this.alertaService.info(err);        
                });
              }else{
                this.alertaService.error(err);
              }
        }
    });
  }

  getErrorMessageVotacion() {
    return this.votacionValidacion.hasError('required') ? 'Campo Obligatorio ' : '';
  }
}
